import React from "react";

const Spinner = () => {
  return (
    <div className="flex justify-center items-center h-[90vh]">
      <button className="btn loading">Loading</button>
    </div>
  );
};

export default Spinner;
